export const ActivitiesSalesPermissions =
{
    AddNewActivity: {
        "permissionsId": "b3bdce27-ef90-47e3-c9e7-08d92ff25bf0",
        "permissionsName": "Add new activity",
        "componentsId": null,
        "components": null
    },
    ViewAndSearchInSaleActivities: {
        "permissionsId": "524b0d97-2a51-4db6-c9e8-08d92ff25bf0",
        "permissionsName": "View and search in sale Activities",
        "componentsId": null,
        "components": null
    },
    ViewActivityDetails: {
        "permissionsId": "0317a2fb-4f3e-4ee0-c9e9-08d92ff25bf0",
        "permissionsName": "View Activity details",
        "componentsId": null,
        "components": null
    },
    EditActivity: {
        "permissionsId": "a91068f8-3c57-464e-c9ea-08d92ff25bf0",
        "permissionsName": "Edit Activity ",
        "componentsId": null,
        "components": null
    }
};
